import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as moment from 'moment';
import {EvsProductService} from '../../../../common/services/EvsProduct.service';
import {StaticStampService} from '../../../../common/services/StaticStamp.service';
import * as _ from 'lodash';
import {environment} from '../../../../../environments/environment';
import {ImageService} from '../../../imageService';
import {ModalHistoryComponent} from './modal/modalHistory.component';
import {ModalReportComponent} from './modal/modalReport.component';
import {EvsStoreService} from 'app/common/services/EvsStore.service';
import * as auth from '../../../../common/actions/authentication';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../common/reducers';

declare var $: any;

@Component({
  selector: 'static-stamp',
  templateUrl: './static.component.html',
  styleUrls: ['./static.component.css'],
  providers: [EvsProductService, StaticStampService, BsModalService],
})
export class StaticComponent implements OnInit {
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  public products: any = [];
  public stores: any = [];
  public list: any = [];

  public page_size: number = 10;
  public currentPage: number = 1;
  public totalItem: number = 0;
  public totalPage: number = 0;

  public mode: any = 'add';
  public item_detail: any;
  public templates: any = [];
  public model: any = {};
  public modelExpire: any = {};
  public message: any = null;
  public modalRef2: any;
  public modalRef3: any;
  public choice_template: any;
  public stamp_url: any;
  public modelFilter: any = {};
  public type: any = 'product';
  public qrcodeSvg: any = '';
  bsModalRef: BsModalRef;
  @ViewChild('templateLK') templateLK;

  constructor(
    private productService: EvsProductService,
    private storeService: EvsStoreService,
    private staticService: StaticStampService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private router: Router,
    private imageService: ImageService,
    private store: Store<fromRoot.State>
  ) {
  }

  ngOnInit() {
    this.loadData();
    // this.loadProducts();
    $('#filter_product_id').select2({
      placeholder: 'Sản phẩm',
      allowClear: false,
    });
    $('#filter_status').select2({
      placeholder: 'Trạng thái',
      allowClear: false,
    });
    if (!(JSON.parse(localStorage.getItem('User')) && JSON.parse(localStorage.getItem('User')).icheck_id)) {
      this.openModalLK(this.templateLK)
    }

  }

  openModalLK(template: TemplateRef<any>) {
    this.modalRef3 = this.modalService.show(template);
  }

  lkLink() {
    this.modalRef3.hide();
    this.store.dispatch(new auth.LogoutAction());
    this.router.navigate(['/link-account']);
  }

  productId: any = null;

  changeProduct(event) {
    this.productId = event ? event : null;
  }

  productGimProductId: any = null;

  changeProductGimProduct(event) {
    this.productGimProductId = event ? event : null;
  }

  storeGimId: any = null;

  changeStoreGim(event) {
    this.storeGimId = event ? event : null;
  }

  loadData(request: any = {}, sort: any = {}) {
    request = {
      name: this.modelFilter.name,
      status: $('#filter_status').val(),
      product_id: this.productId ? this.productId : null,
    };
    this.list = [];
    request.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.staticService
      .listStamp(request)
      .toPromise()
      .then(
        (res) => {
          if (res.status == 200) {
            this.list = res.data.list;

            for (let i = 0; i < this.list.length; i++) {
              this.list[i].product_image = this.imageService.readSrcImage(
                this.list[i].product_image,
                'thumb_medium'
              );
            }
            this.totalItem = res.data.total;
            var pageString = (this.totalItem / this.page_size).toString();
            var pageSplit = pageString.split('.');
            var last: any;
            var totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
            if (
              this.list.length > 0 &&
              (this.mode != 'edit' || _.isEmpty(this.model))
            ) {
              this.viewDetail(this.list[0]);
            }
          } else {
            this.list = [];
          }
        },
        (err) => {
          this.list = [];
        }
      );
  }

  loadStore() {
    this.storeService.getAll({limit: 500}).subscribe((res) => {
      if (!res.error && res.status == 200) {
        this.stores = res.data.store;
      }
    });
  }

  ResetFormSearch() {
    this.modelFilter = {};
    $('#filter_status').val('').trigger('change');
    $('#filter_product_id').val('').trigger('change');
    this.loadData();
  }

  submitFilter() {
    this.model = {};
    this.mode = 'add';
    this.stamp_url = null;
    let payload = {
      name: this.modelFilter.name,
      status: $('#filter_status').val(),
      product_id: $('#filter_product_id').val(),
    };
    this.loadData(payload);
  }

  productGimProduct: any;
  storeGim: any;

  viewDetail(stamp) {
    this.message = null;
    this.model = stamp;
    this.model.alert_message = this.model.message;
    this.mode = 'edit';
    this.item_detail = stamp;
    this.item_detail.publish_app = stamp.only_icheck ? false : true;
    this.model.publish_app = stamp.only_icheck ? false : true;
    if (this.model.code) {
      this.stamp_url = environment.url_static_stamp + '/?q=' + this.model.code;
    } else {
      this.stamp_url = null;
    }
    if (this.model.product_id && this.model.product_name) {
      this.productGimProduct = {
        label: this.model.product_name,
        value: this.model.product_id.toString(),
      };
    }
    if (this.model.store_id && this.model.store_name.name) {
      this.storeGim = {
        label: this.model.store_name.name,
        value: this.model.store_id.toString(),
      };
    }

    this.type = this.model.type ? this.model.type : 'product';
    this.loadTempalate(this.type);
    // if (this.type == "product") this.loadProducts();
    if (this.type == 'store') {
      this.loadStore();
    }

    // setTimeout(function() {
    this.choice_template = _.find(this.templates, {
      id: this.model.template_id,
    });
    setTimeout(() => {
      $('#choice_product').select2({
        placeholder: 'Chọn sản phẩm',
        allowClear: false,
      });
    }, 50);
    // }.bind(this), 400);

    setTimeout(()=> {
      this.qrcodeSvg = $('.qrcodeSvg img').attr('src')
    },500)
  }

  copy() {
    const inputElement = document.getElementById('url_stamp');
    (<any>inputElement).select();
    document.execCommand('copy');
    this.toastr.success('Đã copy', '', {
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
    });
  }

  deActive(status) {
    this.staticService
      .updateStamp(this.model.id, {status: status})
      .subscribe((res) => {
        if (!res.error && res.status == 200) {
          this.toastr.success('Cập nhật tem thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.model.status = status;
          this.loadData();
        } else {
          this.toastr.error('Cập nhật tem không thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
  }

  choiceTemplate(template) {
    this.choice_template = template;
    this.model['template_id'] = template.id;
  }

  // loadProducts() {
  //   this.productService.listProduct({ limit: 500 }).subscribe((res) => {
  //     if (!res.error && res.status == 200) {
  //       this.products = res.data.products;
  //     }
  //   });
  // }

  openMode(mode) {
    this.loadTempalate();
    // $("#choice_product").select2({
    //   placeholder: "Chọn sản phẩm",
    //   allowClear: false,
    // });
    this.productGimProduct = null;
    this.storeGim = null;

    $('#choice_store').select2({
      placeholder: 'Chọn cửa hàng',
      allowClear: false,
    });
    this.model = {
      show_product: true,
      show_distributor: true,
      show_vendor: true,
      show_related: true,
      show_store: true,
      show_message: true,
      show_price: true,
      show_info: true,
      expire: 1,
      require_profile: true,
      publish_app: true,
    };
    this.mode = mode;
    this.message = null;
    this.stamp_url = null;
    this.choice_template = null;
    this.type = 'product';
    $('#choice_product').val('').trigger('change');

    $('#choice_store').val('').trigger('change');
  }

  saveLink() {
    if (!this.model.link) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Địa chỉ link không được bỏ trống',
      };
    } else {
      let payload = {
        link: this.model.link,
        type: this.type,
        name: this.model.link,
      };
      if (this.mode == 'add') {
        if (!this.model.expire) {
          this.message = {
            class: 'alert alert-danger',
            content: 'Năm đăng ký không được bỏ trống',
          };
        } else {
          payload['code'] = moment().valueOf();
          payload['status'] = 'pending';
          payload['expired_time'] = moment()
            .add(this.model.expire, 'years')
            .format('YYYY-MM-DD HH:mm:ss');
          this.staticService.createStamp(payload).subscribe((res) => {
            if (!res.error && res.status == 200) {
              this.toastr.success('Tạo mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadData();
            } else {
              this.toastr.error('Tạo mới không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            }
          });
        }
      } else {
        let stamp_id = this.model.id;
        this.staticService.updateStamp(stamp_id, payload).subscribe((res) => {
          if (!res.error && res.status == 200) {
            this.toastr.success('Cập nhật tem thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
          } else {
            this.toastr.error('Cập nhật tem không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          }
        });
      }
    }
  }

  save() {
    this.model['product_id'] = this.productGimProductId
      ? this.productGimProductId
      : this.model['product_id'];

    if (this.type == 'link' && !this.model.link) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Địa chỉ link không được bỏ trống',
      };
    }
    if (!this.model.name) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Tên con tem không được bỏ trống',
      };
    } else if (!this.model.product_id) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Sản phẩm không được bỏ trống',
      };
    } else if (!this.model.template_id) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Bạn chưa chọn mẫu tem',
      };
    } else {
      let payload = {
        name: this.model.name,
        product_id: this.model.product_id,
        message: this.model.alert_message
          ? this.model.alert_message.trim()
          : null,
        template_id: this.model.template_id,
        expire: this.model.expire,
        show_product: this.model.show_product,
        show_distributor: this.model.show_distributor,
        show_vendor: this.model.show_vendor,
        show_related: this.model.show_related,
        show_store: this.model.show_store,
        show_message: this.model.show_message,
        show_price: this.model.show_price,
        show_info: this.model.show_info,
        type: this.type,
        link: this.model.link,
        require_profile: this.model.require_profile,
        only_icheck: this.model.publish_app ? 0 : 1,
      };
      payload['expired_time'] = moment()
        .add(payload.expire, 'years')
        .format('YYYY-MM-DD HH:mm:ss');
      delete payload.expire;

      if (this.mode == 'add') {
        if (!this.model.expire) {
          this.message = {
            class: 'alert alert-danger',
            content: 'Năm đăng ký không được bỏ trống',
          };
        } else {
          payload['code'] = moment().valueOf();
          payload['status'] = 'pending';
          this.staticService.createStamp(payload).subscribe((res) => {
            if (!res.error && res.status == 200) {
              this.toastr.success('Tạo mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadData();
            } else {
              this.toastr.error('Tạo mới không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            }
          });
        }
      } else {
        let stamp_id = this.model.id;
        delete payload['expired_time'];
        this.staticService.updateStamp(stamp_id, payload).subscribe((res) => {
          if (!res.error && res.status == 200) {
            this.toastr.success('Cập nhật tem thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
          } else {
            this.toastr.error('Cập nhật tem không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          }
        });
      }
    }
  }

  saveStore() {
    this.model['store_id'] = this.storeGimId
      ? this.storeGimId
      : this.model['store_id'];

    if (!this.model.name) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Tên con tem không được bỏ trống',
      };
    } else if (!this.model.store_id) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Cửa hàng không được bỏ trống',
      };
    } else if (!this.model.template_id) {
      this.message = {
        class: 'alert alert-danger',
        content: 'Bạn chưa chọn mẫu tem',
      };
    } else {
      let payload = {
        name: this.model.name,
        store_id: this.model.store_id,
        message: this.model.alert_message
          ? this.model.alert_message.trim()
          : null,
        template_id: this.model.template_id,
        expire: this.model.expire,
        show_product: this.model.show_product,
        show_store: this.model.show_store,
        show_message: this.model.show_message,
        type: this.type,
        require_profile: this.model.require_profile,
        only_icheck: this.model.publish_app ? 0 : 1,
      };
      payload['expired_time'] = moment()
        .add(payload.expire, 'years')
        .format('YYYY-MM-DD HH:mm:ss');
      delete payload.expire;

      if (this.mode == 'add') {
        if (!this.model.expire) {
          this.message = {
            class: 'alert alert-danger',
            content: 'Năm đăng ký không được bỏ trống',
          };
        } else {
          payload['code'] = moment().valueOf();
          payload['status'] = 'pending';
          this.staticService.createStamp(payload).subscribe((res) => {
            if (!res.error && res.status == 200) {
              this.toastr.success('Tạo mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadData();
            } else {
              this.toastr.error('Tạo mới không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            }
          });
        }
      } else {
        let stamp_id = this.model.id;
        delete payload['expired_time'];
        this.staticService.updateStamp(stamp_id, payload).subscribe((res) => {
          if (!res.error && res.status == 200) {
            this.toastr.success('Cập nhật tem thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
          } else {
            this.toastr.error('Cập nhật tem không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          }
        });
      }
    }
  }

  changeType(type) {
    this.type = type;
    if (type == 'store') {
      this.loadStore();
    }
    // if (type == "product") this.loadProducts();
    this.loadTempalate(type);
  }

  loadTempalate(type: string = null) {
    let payload = {
      offset: 0,
      limit: 100,
      fileds: 'id name, status, image',
      type: type || 'product',
    };

    this.staticService.listTemplate(payload).subscribe((res) => {
      if (!res.error && res.status == 200) {
        this.templates = res.data.list;
        for (let i = 0; i < this.templates.length; i++) {
          this.templates[i].image = this.imageService.readSrcImage(
            this.templates[i].image,
            'thumb_medium'
          );
        }
      }
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modelExpire['request_expired'] = '1';
    this.modalRef2 = this.modalService.show(template);
  }

  requestExpire() {
    this.staticService
      .updateStamp(this.model.id, this.modelExpire)
      .subscribe((res) => {
        if (!res.error && res.status == 200) {
          this.toastr.success('Gia hạn thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.loadData();
        } else {
          this.toastr.error('Gia hạn không thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
  }

  redirectToCustomer(id) {
    this.router.navigate(['/qrcode/customer/list'], {
      queryParams: {static_stamp_id: id},
    });
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  showHistory(id) {
    const initialState = {
      stamp_id: id,
    };
    this.bsModalRef = this.modalService.show(ModalHistoryComponent, {
      class: 'modal-lg',
      initialState,
    });
    this.bsModalRef.content.closeBtnName = 'Bỏ qua';
  }

  showReport(id) {
    const initialState = {
      stamp_id: id,
    };
    this.bsModalRef = this.modalService.show(ModalReportComponent, {
      class: 'modal-lg',
      initialState,
    });
    this.bsModalRef.content.closeBtnName = 'Bỏ qua';
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/static_stamp/static.component.ts